module.exports = __webpack_public_path__ + "img/cate2.c57f0fef.jpg";